import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { Contribution, ImportResult } from './contribution.types';
import { ActiveFilter } from '@utils/filters';

const contributionApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        importContributions: build.mutation<ApiResponse<ImportResult>, { fileId: number }>({
            query: ({ fileId }) => {
                return {
                    url: `/member/contribution/import`,
                    method: 'POST',
                    body: { fileId }
                };
            },
            transformResponse: (response: ApiResponse<ImportResult>) => response
        }),
    getContributionsEdition: build.mutation<
        ApiPaginationResponse<Contribution>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
    >({
        query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
            return {
                url: `/member/contributions/edition`,
                method: 'GET',
                params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
            };
        },
        transformResponse: (response: ApiPaginationResponse<Contribution>) => response
    }),
    getContributionsExport: build.mutation<ApiResponse<string>, {search?: string; orderBy?: string; filters?: ActiveFilter[] }>({
        query: ({ search, orderBy, filters }) => {
            return {
                url: `/member/contributions/edition/export`,
                method: 'GET',
                params: { search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
            };
        },
        transformResponse: (response: ApiResponse<string>) => response
    }),
    })
});

export const { 
    useImportContributionsMutation,
    useGetContributionsEditionMutation,
    useGetContributionsExportMutation
} = contributionApi;
